import {
  Box,
  IconButton,
  Stack,
  Typography,
  Button,
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

import Images from "../utils/Images";

const stopCardOpen = (event) => {
  event.stopPropagation();
};

const FoodTypeIndicator = ({ nature }) => {
  if (!nature) return null;

  const value = nature?.toLowerCase();

  const isVeg = value === "veg" || value === "vegetarian";
  const isVegan = value === "vegan";

  const indicatorColor = isVeg || isVegan ? "#009688" : "#D32F2F";

  return (
    <Box
      sx={{
        width: 14,
        height: 14,
        border: `2px solid ${indicatorColor}`,
        borderRadius: "3px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
      }}
    >
      <Box
        sx={{
          width: 9,
          height: 9,
          borderRadius: "50%",
          backgroundColor: indicatorColor,
        }}
      />
    </Box>
  );
};

const ProductCard = ({
  product,
  price,
  quantity = 0,
  onSelect,
  onIncrease,
  onDecrease,
}) => {
  const handleSelect = () => {
    onSelect?.();
  };

  const productImage = product?.displayImageUrl;

  return (
    <Box
      onClick={handleSelect}
      sx={{
        width: "100%",
        cursor: "pointer",
        backgroundColor: "#fff",
      }}
    >
      <Box
        sx={{
          minHeight: {
            xs: 145,
            sm: 160,
          },

          px: {
            xs: 1.5,
            sm: 2,
          },

          // py: {
          //   xs: 2,
          //   sm: 2.5,
          // },

          display: "grid",

          gridTemplateColumns: {
            xs: "105px minmax(0, 1fr)",
            sm: "135px minmax(0, 1fr)",
          },

          alignItems: "center",

          columnGap: {
            xs: 1.8,
            sm: 2.5,
          },
        }}
      >

        <Box
          sx={{
            height: {
              xs: 100,
              sm: 130,
            },
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
            flexShrink: 0,
          }}
        >
          <Box
            component="img"
            src={productImage}
            alt={product?.name || "Product"}
            onError={(event) => {
              event.currentTarget.onerror = null;
              event.currentTarget.src = Images.product;
            }}
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
              objectPosition: "center",
              display: "block",
            }}
          />
        </Box>

        <Box
          sx={{
            minWidth: 0,
            alignSelf: "stretch",

            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Typography
            sx={{
              fontSize: {
                xs: 16,
                sm: 21,
              },

              lineHeight: 1.18,
              fontWeight: 700,

              color: "#074B66",

              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
            }}
          >
            {product?.name || "Product"}
          </Typography>

          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            spacing={1.2}
            sx={{
              mt: {
                xs: 2,
                sm: 2.5,
              },
            }}
          >
            <Stack
              direction="row"
              alignItems="center"
              spacing={1.2}
              sx={{ minWidth: 0 }}
            >
              <FoodTypeIndicator nature={product?.foodType} />

              <Typography
                sx={{
                  fontSize: {
                    xs: 16,
                    sm: 18,
                  },

                  lineHeight: 1,
                  fontWeight: 600,

                  color: "#919191",
                  flexShrink: 0,
                }}
              >
                ₹{Number(price || 0)}
              </Typography>
            </Stack>

            <Box
              onClick={stopCardOpen}
              onMouseDown={stopCardOpen}
              onTouchStart={stopCardOpen}
              onPointerDown={stopCardOpen}
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                flexShrink: 0,
              }}
            >
              
          {quantity > 0 ? (
            <Box
              sx={{
                height: {
                  xs: 38,
                  sm: 50,
                },

                width: {
                  xs: 100,
                  sm: 140,
                },

                borderRadius: "28px",

                border: "2px solid #09A5F7",

                backgroundColor: "#fff",

                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",

                px: {
                  xs: 0.65,
                  sm: 0.45,
                },
              }}
            >
              {/* Minus */}

              <IconButton
                aria-label={`Remove one ${product?.name || "product"
                  }`}
                onClick={(event) => {
                  stopCardOpen(event);
                  onDecrease?.();
                }}
                sx={{
                  width: {
                    xs: 26,
                    sm: 30,
                  },

                  height: {
                    xs: 26,
                    sm: 30,
                  },

                  backgroundColor: "#20A5EA",
                  color: "#fff",

                  "&:hover": {
                    backgroundColor: "#0795DF",
                  },
                }}
              >
                <RemoveIcon
                  sx={{
                    fontSize: {
                      xs: 21,
                      sm: 27,
                    },
                  }}
                />
              </IconButton>

              {/* Quantity */}

              <Typography
                sx={{
                  minWidth: 24,

                  textAlign: "center",

                  fontSize: {
                    xs: 22,
                    sm: 28,
                  },

                  lineHeight: 1,

                  fontWeight: 600,

                  color: "#0D0D0D",
                }}
              >
                {quantity}
              </Typography>

              {/* Plus */}

              <IconButton
                aria-label={`Add one ${product?.name || "product"
                  }`}
                onClick={(event) => {
                  stopCardOpen(event);

                  if (onIncrease) {
                    onIncrease();
                  } else {
                    handleSelect();
                  }
                }}
                sx={{
                  width: {
                    xs: 26,
                    sm: 30,
                  },

                  height: {
                    xs: 26,
                    sm: 30,
                  },

                  backgroundColor: "#20A5EA",
                  color: "#fff",

                  "&:hover": {
                    backgroundColor: "#0795DF",
                  },
                }}
              >
                <AddIcon
                  sx={{
                    fontSize: {
                      xs: 21,
                      sm: 27,
                    },
                  }}
                />
              </IconButton>
            </Box>
          ) : (
            <Button
              onClick={(event) => {
                stopCardOpen(event);
                handleSelect();
              }}
              variant="outlined"
              sx={{
                width: {
                  xs: 100,
                  sm: 140,
                },

                height: {
                  xs: 33,
                  sm: 38,
                },

                borderRadius: "28px",

                borderWidth: "2px",
                borderColor: "#09A5F7",

                color: "#074B66",

                backgroundColor: "#fff",

                textTransform: "none",

                fontSize: {
                  xs: 12,
                  sm: 14,
                },

                fontWeight: 500,

                "&:hover": {
                  borderWidth: "2px",
                  borderColor: "#09A5F7",
                  backgroundColor: "#F5FCFF",
                },
              }}
            >
              Add
            </Button>
          )}
            </Box>
          </Stack>
        </Box>
      </Box>
    </Box>
  );
};

export default ProductCard;